namespace nscs.character {

    export class Boss extends Phaser.GameObjects.Container {

        greenLeft_mc:Phaser.GameObjects.Image;
        greenRight_mc:Phaser.GameObjects.Image;
        redLeft_mc:Phaser.GameObjects.Image;
        redRight_mc:Phaser.GameObjects.Image;

        private lives:number = 4;

        ronald_mc:Phaser.GameObjects.Sprite;
        shacklerXMC:Phaser.Physics.Arcade.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene, 0, 0);

            this.shacklerXMC = nscs.scene.MainScene.instance.physics.add.sprite( 0, 0,'boss-atlas', 'shacklerXMC'+'0000');
            this.shacklerXMC.setOrigin(0.5, 0);
            this.shacklerXMC.setBounce(0);
            this.shacklerXMC.setCollideWorldBounds(false);
            this.shacklerXMC.setImmovable(true);
            this.shacklerXMC.body["setAllowGravity"](false);
            this.shacklerXMC.body.setSize(105, 65);
            this.shacklerXMC.body.setOffset(30, 60);

            this.add(this.shacklerXMC);

            this.greenLeft_mc = new Phaser.GameObjects.Image(this.scene, -39, 87, 'boss-atlas', 'greenLeft_mc'+'0000');
            this.add(this.greenLeft_mc);
            this.greenRight_mc = new Phaser.GameObjects.Image(this.scene, 39, 87, 'boss-atlas', 'greenLeft_mc'+'0000');
            this.add(this.greenRight_mc);
            this.redLeft_mc = new Phaser.GameObjects.Image(this.scene, -39, 87, 'boss-atlas', 'redLeft_mc'+'0000');
            this.add(this.redLeft_mc);
            this.redRight_mc = new Phaser.GameObjects.Image(this.scene, 39, 87, 'boss-atlas', 'redLeft_mc'+'0000');
            this.add(this.redRight_mc);

            let shacklerXMC_animations = {
                'showTenons':{'start': 0, 'end':61,'showTenons':120},
                'idle':{'start': 61, 'end':61,'showTenons':60},
                'hit':{'start': 62, 'end':227,'showTenons':60},
                'stomp':{'start': 228, 'end':279,'showTenons':60}
            };
            for (let k in shacklerXMC_animations) {
                let anim:string = nscs.gameplay.Factory.createAnimName(k, 'shacklerXMC');
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(this.shacklerXMC.texture.key, {
                            start: shacklerXMC_animations[k]['start'], end: shacklerXMC_animations[k]['end'], zeroPad: 4,
                            prefix: 'shacklerXMC', suffix: ''
                        }),
                        frameRate: shacklerXMC_animations[k]['showTenons']
                    });
                }
            }

            this.shacklerXMC.on('animationcomplete', ()=>{this.currAnimComplete = true;});

            this.ronald_mc = nscs.scene.MainScene.instance.factory.createRonaldSprite();
            this.ronald_mc.setOrigin(0.57, 0.2);
            this.ronald_mc.setPosition(0, 0);
            this.add(this.ronald_mc);

            this.visible = false;
        }

        private underScreenPositionY:number;

        private player:nscs.character.Player = null;
        private minX:number;
        private maxX:number;
        private topY:number;
        private bottomY:number;
        private onDieCallback;
        private onAttackCallback;
        public setup(player:nscs.character.Player, minX:number, maxX:number, topY:number, bottomY:number, onDieCallback, onAttackCallback):void {
            this.player = player;
            this.minX = minX;
            this.maxX = maxX;
            this.topY = topY;
            this.bottomY = bottomY;
            this.onDieCallback = onDieCallback;
            this.onAttackCallback = onAttackCallback;

            this.underScreenPositionY = this.bottomY + 300;
        }

        private currAnimComplete:boolean = true;
        private currAnim:string = null;
        private playAnimation(anim:string):void {
            if (anim != this.currAnim) {
                this.shacklerXMC.anims.stop();
            }
            this.currAnim = anim;
            this.currAnimComplete = false;
            this.shacklerXMC.anims.play(nscs.gameplay.Factory.createAnimName(anim, 'shacklerXMC'), true);
        }

        private currTween:Phaser.Tweens.Tween = null;
        private doAction(action:string):void {
            // console.log(action);
            this.destroyCurrTween();
            this.currAction = action;

            if (action == 'y-idle') {
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    y: this.topY + (Math.random()*0.1 + 0.1)*(this.bottomY-this.topY),
                    duration: (250 + Math.random()*250)*0.75,
                    repeat: 1,
                    yoyo:true,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: ()=>this.nextAction(),
                    onRepeat:()=>{
                        if (this.ronald_mc.anims.getCurrentKey() == 'disappear') {
                            this.ronald_mc.play('appear');
                        }
                    }
                });
                this.playAnimation('idle');
                if (Math.random() > 0.5) {
                    this.ronald_mc.play('disappear');
                } else {
                    this.ronald_mc.play('midLaugh');
                    nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND','laugh2SND','laugh3SND']))
                }
            } else if (action == 'follow-player') {
                let x:number = this.player.sprite.x + (Math.random()-0.5)*60;
                if (x > this.maxX - this.shacklerXMC.width / 2) {
                    x = this.maxX - this.shacklerXMC.width / 2;
                } else if (x < this.minX + this.shacklerXMC.width / 2) {
                    x = this.minX + this.shacklerXMC.width / 2;
                }
                let rnd:number = Math.random();
                let nextAnim:string='attack-down';
                /*if (rnd < 0.1) {
                    nextAnim = 'y-idle';
                } else */if (rnd < 0.5 || Math.abs(this.player.sprite.x - this.x) > 100) {
                    nextAnim = 'follow-player';
                } else {
                    nextAnim = 'attack-down';
                }
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    x: x,
                    y: Math.random() > 0.5 || nextAnim == 'attack-down' ? this.topY : this.y,
                    duration: 2000 + Math.random()*1000,
                    ease: Phaser.Utils.Array.GetRandom([Phaser.Math.Easing.Sine.Out,Phaser.Math.Easing.Back.In,Phaser.Math.Easing.Back.Out]),
                    onComplete: ()=>this.nextAction(nextAnim)
                });
                this.playAnimation('idle');
                this.ronald_mc.play('laugh');
                nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND','laugh2SND','laugh3SND']))
                nscs.sound.SoundManager.getInstance().playSound('bossMoveSND');
            } else if (action == 'attack-down') {
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    y: this.bottomY,
                    duration: 250,
                    delay: (1000 + Math.random() * 500)*0.75,
                    ease: Phaser.Math.Easing.Sine.In,
                    onComplete: ()=>{
                        this.currTween = this.scene.tweens.add({
                            targets: this,
                            y: this.bottomY - 4,
                            duration: (3000)*0.75,
                            onComplete: ()=>{
                                this.nextAction(Math.random() > 0.5 ? 'move-up' : 'follow-player')
                            }
                        });
                        this.ronald_mc.play('appear');

                        nscs.sound.SoundManager.getInstance().playSound('bossStompSND');
                    },
                    onStart: ()=>{
                        this.playAnimation('stomp');
                    }
                });
                this.ronald_mc.play('disappear');
                nscs.sound.SoundManager.getInstance().playSound('bossPowerSND');
                nscs.sound.SoundManager.getInstance().playSound('bossHomingSND');
            } else if (action == 'move-up') {
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    y: this.topY,
                    duration: (1500)*0.75,
                    ease: Phaser.Math.Easing.Back.Out,
                    onComplete: ()=>this.nextAction('y-idle')
                });
                this.playAnimation('showTenons');
                if (this.ronald_mc.anims.getCurrentKey() != 'appear') {
                    this.ronald_mc.play('appear');
                }
                nscs.sound.SoundManager.getInstance().playSound('bossRiseSND');
                nscs.sound.SoundManager.getInstance().playSound('bossSpikesSND');
            } else if (action == 'hide-under-screen') {
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    y: this.underScreenPositionY,
                    duration: (1500)*0.75,
                    delay: (1500)*0.75,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onStart: ()=>this.ronald_mc.play('disappear')
                });
                this.playAnimation('hit');
                this.ronald_mc.play('disappear');
                nscs.sound.SoundManager.getInstance().playSound('bossBaffSND');
            } else if (action == 'hit') {
                this.currTween = this.scene.tweens.add({
                    targets: this,
                    y: this.y,
                    duration: (500 + Math.random() * 2000)*0.75,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: ()=>this.nextAction()
                });
                this.playAnimation('hit');
                this.ronald_mc.play('hit');
                nscs.sound.SoundManager.getInstance().playSound('bossBaffSND');
            }
        }

        public showUp():void {
            this.visible = true;
            this.y = this.underScreenPositionY;
            this.nextAction('move-up');
        }

        private destroyCurrTween():void {
            if (this.currTween) {
                this.scene.tweens.remove(this.currTween);
                this.currTween = null;
            }
        }

        public hideDown():void {
            this.destroyCurrTween();
            this.nextAction('hide-under-screen');
        }

        private currAction:string = null;
        public nextAction = (nextAction:string = null) => {
            if (this.lives <= 0) {
                return;
            }

            if (typeof nextAction != "string") {
                let rnd:number = Math.random();
                /*if (rnd <= 0.1) {
                    nextAction = 'y-idle';
                } else */if (rnd <= 0.7) {
                    nextAction = 'follow-player';
                } else if (rnd <= 1) {
                    nextAction = 'attack-down';
                }
            }

            this.doAction(nextAction);
        };

        public hit():void {
            if (this.lives <= 0) return;

            this.lives--;

            if (this.lives == 0) {
                this.doAction('hide-under-screen');
                this.onDieCallback();
            } else {
                this.doAction('hit');
            }
            nscs.sound.SoundManager.getInstance().playSound('hairballHitSND');
        }

        private isPlayerEnteredBattle:boolean = false;

        private ticker:number = 0;
        public updateBoss():void {
            if (!this.isPlayerEnteredBattle) {
                if (this.player.sprite.y > this.topY) {
                    this.isPlayerEnteredBattle = true;
                    this.showUp();
                }
                return;
            }

            this.ronald_mc.scaleX = this.player.sprite.x > this.x ? -1 : 1;
            let overlaps:boolean = this.scene.physics.world.collide(this.player.sprite, this.shacklerXMC);
            if (overlaps) {
                if (this.shacklerXMC.body.touching.up) {
                    if (this.currAnim != 'hit' && this.currAnim != 'hide-under-screen') {
                        this.hit();
                    }

                    this.player.doJump(1);
                    this.player.doSideJump(this.player.sprite.x < this.x ? -3 : 3);
                } else {
                    if (!((this.shacklerXMC.body.touching.right || this.shacklerXMC.body.touching.left) && this.currAnim == 'stomp')) {
                        this.onAttackCallback();
                        this.player.onRespawn = ()=>{
                            this.isPlayerEnteredBattle = false;
                            this.visible = false;
                        };

                        nscs.sound.SoundManager.getInstance().playSound('thumpSND');
                    }
                    this.player.doSideJump(this.player.sprite.x < this.x ? -2 : 2);
                }
            }

            this.updateLights();

            this.ticker++;
        }

        private updateLights():void {
            this.redLeft_mc.visible = this.redRight_mc.visible = this.greenLeft_mc.visible = this.greenRight_mc.visible = false;

            if (this.currAnim != 'stomp' && this.currAction == 'attack-down') {
                this.redLeft_mc.visible = this.redRight_mc.visible = this.ticker % 20 > 10;
            } else {
                if (this.currAnim == 'follow-player' || this.currAnim == 'idle') {
                    this.greenLeft_mc.visible = this.ticker % 45 > 25;
                    this.greenRight_mc.visible = this.ticker % 60 > 30;
                }
            }
        }

        public destroy(fromScene?: boolean): void {
            this.destroyCurrTween();
            super.destroy(fromScene);
        }
    }
}